export default __webpack_public_path__ + "90368aca3229d4899844acc3acdc787f.png";